
import { Vue } from "vue-class-component";

export default class SocialList extends Vue {}
